import { Feature } from '@tencent/workbench';
import BaseTitleBarFeature from '@framework/workbench/common/feature/base-titlebar-feature';
import { invokeFileCompression } from '@src/js/common/ark-extensions/dc-components/docs-component-file-zip';
import { POSITIONS } from '@tencent/txdocs-aid';

@Feature()
export class FileCompressionFeature extends BaseTitleBarFeature {
    public constructor() {
        super();
    }

    public compression() {
        invokeFileCompression({ position: POSITIONS.TOOLBAR });
    }
}
